import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { StoreProvider, useStore } from './lib/store';
import Shell from './components/Shell';
import Landing from './pages/Landing';
import Setup from './pages/Setup';
import Home from './pages/Home';
import Vendors from './pages/Vendors';
import AddVendor from './pages/AddVendor';
import VendorDetail from './pages/VendorDetail';
import VendorPayments from './pages/VendorPayments';
import PaymentGuard from './pages/PaymentGuard';
import Prep from './pages/Prep';
import Settings from './pages/Settings';
import About from './pages/About';
import Ringkasan from './pages/Ringkasan';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function RequireProfile({ children }) {
  const { hasProfile } = useStore();
  if (!hasProfile) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/setup" element={<Setup />} />
          <Route
            path="/app"
            element={
              <RequireProfile>
                <Shell />
              </RequireProfile>
            }
          >
            <Route index element={<Home />} />
            <Route path="vendor" element={<Navigate to="/app/transaksi" replace />} />
            <Route path="vendor/baru" element={<AddVendor />} />
            <Route path="vendor/:id" element={<VendorDetail />} />
            <Route path="pembayaran" element={<Navigate to="/app/transaksi" replace />} />
            <Route path="transaksi" element={<VendorPayments />} />
            <Route path="pembayaran/:id/guard" element={<PaymentGuard />} />
            <Route path="persiapan" element={<Prep />} />
            <Route path="pengaturan" element={<Settings />} />
            <Route path="tentang" element={<About />} />
            <Route path="ringkasan" element={<Ringkasan />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  );
}
